import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/vikingbet/images/logo.svg';

export default function Index() {
  return <Image src={logo} maxW="120px" position="relative" top="-0.5" />;
}
